module.exports = __webpack_public_path__ + "img/3.07bf3543.jpeg";